import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authFeatureKey, State } from './auth.reducer';

export const selectAuthFeature = createFeatureSelector<State>(authFeatureKey);

export const selectAuthenticationResult = createSelector(selectAuthFeature, (state) => state.authenticationResult);

export const selectIsAuthenticationUnsuccessful = createSelector(
  selectAuthFeature,
  (state) =>
    state.authenticationResult?.isCanceled || state.authenticationResult?.isPending || state.authenticationResult?.isServerError
);

export const selectAuthenticationQrDataUri = createSelector(selectAuthenticationResult, (state) => state?.qrCode?.dataUri);

export const selectIsAuthenticated = createSelector(selectAuthFeature, (state) => state.authenticationResult.isAuthenticated);

export const selectIsAuthenticatedInAppSuccess = createSelector(
  selectAuthFeature,
  (state) => !!state.isAuthenticatedInAppSuccess
);

export const selectAuthenticationIsLoading = createSelector(selectAuthFeature, (state) => state.isLoading);

export const selectIsAuthenticationInProgress = createSelector(selectAuthFeature, (state) => state.isAuthenticationInProgress);

export const selectIsAuthenticationApproved = createSelector(selectAuthFeature, (state) => state.isAuthenticationApproved);

export const selectIsAuthenticationFromAccessAppSuccessful = createSelector(
  selectAuthFeature,
  (state) => !!state.authenticationResult?.isAccessAppAuthenticationSuccess
);

export const selectAuthenticationHasError = createSelector(selectAuthFeature, (state) => state.hasError);

export const selectMustShowConsentDialog = createSelector(
  selectAuthFeature,
  (state) => !state.consentAccepted && !state.isLoading && !state.hasError && state.authenticationResult.isAuthenticated
);

export const selectHasAcceptedConsent = createSelector(selectAuthFeature, (state) => state.consentAccepted);
export const selectContractNumber = createSelector(selectAuthFeature, (state) => state.contractNumber);

export const selectAuthenticatedAt = createSelector(selectAuthFeature, (state) => state.authenticatedAt);

export const selectIsAccessAppAvailable = createSelector(selectAuthFeature, (state) => state.isAccessAppUnavailable !== true);
